import { Card, Col, Icon } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

const { Meta } = Card

const CustomCard = (props) => {
  const { title, iconType, color, description, linkTo } = props
  return (
    <Col span={6}>
      <Link to={linkTo}>
        <Card
          style={{ minHeight: '20em', marginTop: '1em' }}
          cover={<Icon type={iconType} style={{ fontSize: '8em', marginTop: '0.2em', color }} />}
          {...{ title }}>
          <Meta {...{ description }} />
        </Card>
      </Link>
    </Col>
  )
}
export default CustomCard
